import { render, staticRenderFns } from "./u-pagination-text-underline.vue?vue&type=template&id=f1900d70&scoped=true"
import script from "./u-pagination-text-underline.vue?vue&type=script&lang=js"
export * from "./u-pagination-text-underline.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1900d70",
  null
  
)

export default component.exports